<!-- Large banner with separate person -->

<template>
  <Fragment>
    <img :class="bgColor" alt />
    <div v-if="rightSideImg" class="r-side-img" :style="rightSideImgExtraStyle">
      <img :src="rightSideImg" alt />
    </div>
    <div class="info" :class="extraClass" @click="handleMobileClick">
      <div class="info-con">
        <h3 :style="{ whiteSpace: 'pre-wrap' }">
          <span v-if="isHtml" v-html="sanitizeStr($t(title))" class="title" />
          <span v-else class="title">{{ $t(title) }}</span>
          <div v-if="centerImg" class="center-img">
            <img :src="centerImg" alt />
          </div>
          <span v-if="isHtml" v-html="sanitizeStr($t(subTitle))" class="subTitle" />
          <span v-else class="subTitle">{{ $t(subTitle) }}</span>
        </h3>
        <div class="logo" v-if="logo">
          <img :src="logo" alt="" />
        </div>
      </div>
      <div class="banner_button" v-if="buttonLink">
        <el-button :class="buttonClass" :disabled="buttonDisabled" @click.native.stop="onButtonClick">
          {{ $t(buttonText) }}
        </el-button>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import isMobile from '@/mixins/isMobile';
import DOMPurify from 'dompurify';

export default {
  name: 'BannerItem',
  props: [
    'extraClass',
    'title',
    'subTitle',
    'buttonLink',
    'buttonText',
    'buttonDisabled',
    'tncLink',
    'downloadPic',
    'rightSideImg',
    'rightSideImgExtraStyle',
    'centerImg',
    'logo',
    'bgColor',
    'buttonClass',
    'isHtml'
  ],
  mixins: [isMobile],
  components: { Fragment },
  methods: {
    sanitizeStr(str) {
      return DOMPurify.sanitize(str);
    },
    onButtonClick() {
      window.open(this.buttonLink);
    },
    handleMobileClick() {
      // 移动端点击内容区域跳转
      if (this.isMobile) {
        this.onButtonClick();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './bannerItem.scss';
</style>
